import { render } from "./CustomerViewChannels.vue?vue&type=template&id=3e1e5f4e&scoped=true"
import script from "./CustomerViewChannels.vue?vue&type=script&lang=js"
export * from "./CustomerViewChannels.vue?vue&type=script&lang=js"

import "./CustomerViewChannels.vue?vue&type=style&index=0&id=3e1e5f4e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1e5f4e"]])

export default __exports__